import getContentUrl from "utils-lib/getContentUrl"
import { wmColor } from "themes-lib/wmTheme"
import { Link } from "../Link/LinkContainer"

export const ButtonArrow = ({
  children = ``,
  href = ``,
  onClick = () => {},
  onKeyDown = () => {},
  className = ``,
  alignment = `align-items-center`,
  justification = `justify-content-center justify-content-md-start`,
  analytics_key = ``,
  shouldNotTrackInComponent = false,
  isExternalLink = false,
  disabled = false,
  showGreenIcon = false,
  isBackgroundGreen = false,
  isLinkYellow = false,
  arrowDirection = `right`,
  tabIndex = `0`,
  ariaLabel = ``,
  ariaDescription = ``,
  useWhiteLink = false,
  useUnderlineHover = false,
  isSCA = false,
  elementType = `ButtonArrow`,
  testid = "ButtonArrow",
  useYellowCaret = false,
  target = `_self`,
  linkStyle = ``,
  storyCarouselItem = {},
  ...props
}) => {
  const arrowColor = disabled
    ? `gray`
    : showGreenIcon || !isBackgroundGreen
    ? useYellowCaret
      ? `yellow`
      : `green`
    : `white`

  const textStyle = {}
  if (isBackgroundGreen) {
    textStyle.color = isLinkYellow ? wmColor.primaryYellow : wmColor.white
  }

  const linkstylewitharrows = {}
  if (className.toLowerCase() === "linkstylewitharrows") {
    linkstylewitharrows.color = isLinkYellow
      ? wmColor.primaryYellow
      : wmColor.green2
  }

  return (
    <Link
      testid={testid}
      analytics_key={
        analytics_key !== ``
          ? analytics_key
          : children
          ? children.toString()
          : href
      }
      tabIndex={tabIndex}
      href={href}
      onClick={onClick}
      onKeyDown={onKeyDown}
      disabled={disabled}
      className={`ButtonArrow has-focus maax-font-weight-bold d-flex ${alignment} ${justification} ${className}`}
      shouldNotTrackInComponent={shouldNotTrackInComponent}
      isExternalLink={isExternalLink}
      ariaLabel={ariaLabel}
      ariaDescription={ariaDescription}
      useWhiteLink={useWhiteLink}
      useUnderlineHover={useUnderlineHover}
      isSCA={isSCA}
      elementType={elementType}
      target={target}
      {...props}
    >
      {arrowDirection === `left` ? (
        <>
          <img
            src={getContentUrl(
              `/content/dam/wm/icons/controls/20x20/${arrowColor}/material-ui/arrow-${
                useYellowCaret ? `down.svg` : `open.svg`
              }`,
            )}
            style={{
              display: linkStyle ? "none" : `flex`,
              ...(arrowDirection === `left`
                ? {
                    marginRight: `0.25rem`,
                    transform: `rotate(90deg)`,
                  }
                : {
                    marginLeft: `0.25rem`,
                    transform: `rotate(${
                      arrowDirection === `up`
                        ? 180
                        : arrowDirection === `down`
                        ? 0
                        : -90
                    }deg)`,
                  }),
            }}
            alt=""
            className="arrow"
          />
          <div
            data-testid="ButtonArrow__text"
            className="ButtonArrow__text"
            style={{
              lineHeight: `17px`,
              ...textStyle,
              ...linkstylewitharrows,
            }}
            {...(storyCarouselItem && {
              "aria-describedby": `learnMoreDescription-${storyCarouselItem?.ctaButtonURL}`,
            })}
          >
            {children}
          </div>

          {/* Only visible to screen reader */}
          {storyCarouselItem && (
            <span
              id={`learnMoreDescription-${storyCarouselItem?.ctaButtonURL}`}
              className="sr-only"
            >
              {children}
            </span>
          )}
        </>
      ) : (
        <>
          <div
            data-testid="ButtonArrow__text"
            className="ButtonArrow__text"
            style={{
              lineHeight: `17px`,
              ...textStyle,
              ...linkstylewitharrows,
            }}
            {...(storyCarouselItem && {
              "aria-describedby": `learnMoreDescription-${storyCarouselItem?.ctaButtonURL}`,
            })}
          >
            {children}
          </div>

          {/* Only visible to screen reader */}
          {storyCarouselItem && (
            <span
              id={`learnMoreDescription-${storyCarouselItem.ctaButtonURL}`}
              className="sr-only"
            >
              {storyCarouselItem.description}
            </span>
          )}

          <img
            src={getContentUrl(
              `/content/dam/wm/icons/controls/20x20/${arrowColor}/material-ui/arrow-${
                useYellowCaret ? `down.svg` : `open.svg`
              }`,
            )}
            style={{
              display: linkStyle === "linkStyle" ? "none" : `flex`,
              ...(arrowDirection === `left`
                ? {
                    marginRight: `0.25rem`,
                    transform: `rotate(90deg)`,
                  }
                : {
                    marginLeft: `0.25rem`,
                    height: "20px",
                    width: "20px",
                    transform: `rotate(${
                      arrowDirection === `up`
                        ? 180
                        : arrowDirection === `down`
                        ? 0
                        : -90
                    }deg)`,
                  }),
            }}
            alt=""
            className="arrow"
          />
        </>
      )}
    </Link>
  )
}

// Note: React 19 no-longer supports propTypes. Leaving this for reference.
// ButtonArrow.propTypes = {
//   children: PropTypes.node,
//   href: PropTypes.string,
//   onClick: PropTypes.func,
//   onKeyDown: PropTypes.func,
//   className: PropTypes.string,
//   alignment: PropTypes.string,
//   justification: PropTypes.string,
//   analytics_key: PropTypes.string,
//   shouldNotTrackInComponent: PropTypes.bool,
//   isExternalLink: PropTypes.bool,
//   disabled: PropTypes.bool,
//   showGreenIcon: PropTypes.bool,
//   isBackgroundGreen: PropTypes.bool,
//   isLinkYellow: PropTypes.bool,
//   arrowDirection: PropTypes.string,
//   tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
//   ariaLabel: PropTypes.string,
//   ariaDescription: PropTypes.string,
//   useWhiteLink: PropTypes.bool,
//   useUnderlineHover: PropTypes.bool,
//   isSCA: PropTypes.bool,
//   elementType: PropTypes.string,
//   testid: PropTypes.string,
//   useYellowCaret: PropTypes.bool,
//   target: PropTypes.string,
//   linkStyle: PropTypes.string,
//   storyCarouselItem: PropTypes.object,
// }

// Note: React 19 no-longer supports defaultProps. Leaving this for reference.
// ButtonArrow.defaultProps = {
//   className: ``,
//   alignment: `align-items-center`,
//   justification: `justify-content-center justify-content-md-start`,
//   href: ``,
//   onClick: () => {},
//   onKeyDown: () => {},
//   analytics_key: ``,
//   shouldNotTrackInComponent: false,
//   disabled: false,
//   children: ``,
//   showGreenIcon: false,
//   isBackgroundGreen: false,
//   isLinkYellow: false,
//   arrowDirection: `right`,
//   ariaLabel: ``,
//   ariaDescription: ``,
//   useWhiteLink: false,
//   useUnderlineHover: false,
//   isSCA: false,
//   elementType: `ButtonArrow`,
//   tabIndex: `0`,
//   testid: "ButtonArrow",
//   isExternalLink: false,
//   useYellowCaret: false,
//   target: `_self`,
//   linkStyle: ``,
//   storyCarouselItem: {},
// }
